<template>
    <v-layout wrap class="mx-3">
      <v-flex xs12>
        <v-text-field
          v-model="searchPhrase"
          label="Expertise"
          @keyup.native="search"
          @focus="activateSearch"
          @blur="deactivate"
        ></v-text-field>
      </v-flex>
      <v-flex xs10
        class="search-drop search-drop-down pb"
        v-bind:class="{ searching: searching }"
      >
        <div class="pt-1"></div>
        <div v-for="(item, index) in searchResults" :key="`${index}`">
          <span v-html="item.name" @click="fillInput(item.name)"></span>
        </div>
      </v-flex>
    </v-layout>
</template>

<script>
export default {
  computed: {
    searching() {
      if (this.searchPhrase.trim() !== "" && !this.blured) {
        return true;
      }
      return false;
    }
  },
  data() {
    return {
      searchPhrase: "",
      active: false,
      searchResults: [],
      searchSuggestions: [],
      blured: true
    };
  },
  methods: {
    clearCategory() {
      this.searchPhrase = "";
    },
    search() {
      this.searchPhrase = event.target.value;
      const searchPhrase = this.searchPhrase.trim();
      if (searchPhrase === "") {
        this.$emit("selectedCategory", null);
        return false;
      }
      this.$store.dispatch("getapi", "api/client/expertise/search/" +searchPhrase).then(data => {
        const { expertise } = data;
        this.searchResults = expertise.map(record => {
          return { name: record.category };
        });
      });
      
    },
    fillInput(category){
      this.searchPhrase = category;
      this.$emit("selectedCategory", category);
    },
    deactivate() {
      setTimeout(() => {
        this.blured = true;
      }, 200);
    },
    activateSearch() {
      this.blured = false;
    }
  }
};
</script>

<style scoped>
.search-btn {
  background-color: #ff4500;
  border-radius: 0px;
  color: #fff;
}

.search-btn:hover {
  background-color: orange;
  border-radius: 0px;
  color: #fff;
}

.search-btn:focus {
  box-shadow: none;
  -webkit-box-shadow: none;
  border-color: #cccccc;
}

.search-input-box:focus {
  box-shadow: none;
  -webkit-box-shadow: none;
  border-color: #cccccc;
}
.search-drop-down {
  /* min-height: 40px; */
  /* transition: all 0.3s ease-in-out; */
  position: absolute;
  margin-top: 40px;
  z-index: 300;
}

/* drop down styles */
.search-drop {
  background: #fff;
  transition: all 0.3s ease-in-out;
  border-top: 1px solid #e3e3e3;
  transform: scaleY(0);
  transform-origin: top;
  transition: transform 0.26s ease;
  box-shadow: 2px 2px 4px #bdbdbd;
  cursor: pointer;
}
.searching {
  min-height: 30px;
  /* transition: all 0.3s ease-in-out; */
  transform: scaleY(1);
}
.faint {
  color: #e0e0e0;
}
</style>